import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService } from '@cupoui/core/services/http.service';
import { Ticket } from '@cupoui/shared/model/Ticket';

@Injectable({
  providedIn: 'root'
})
export class TableauService {
  constructor(private httpService: HttpService) {}

  public getTicket(profileCode: string): Observable<string> {
    return this.httpService.get<Ticket>(`/services/api/tableau/ticket/${profileCode}`).pipe(map(response => response.ticket));
  }
}
